// src/components/FavoritesModal.jsx
import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../views/firebaseConfig';
import { useAuth } from '../contexts/AuthContext';
import { Modal, Spinner, ListGroup, Button } from 'react-bootstrap';
import PostCard from '../components/PostCard';

export default function FavoritesModal({ onClose }) {
  const { user } = useAuth();
  const userId = user?.uid;
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null);

  // Fetch favorite post IDs & their full documents
  useEffect(() => {
    if (!userId) return;

    (async () => {
      setLoading(true);
      try {
        const favRef = doc(firestore, 'feedExperience', userId);
        const favSnap = await getDoc(favRef);
        const favoriteIds = favSnap.exists() ? favSnap.data().favorites || [] : [];

        const posts = [];
        for (let postId of favoriteIds) {
          const postRef = doc(firestore, 'feedPost', postId);
          const postSnap = await getDoc(postRef);
          if (postSnap.exists() && postSnap.data().status !== 'inactive') {
            posts.push({ id: postSnap.id, ...postSnap.data() });
          }
        }
        setFavorites(posts);
      } catch (err) {
        console.error('Error fetching favorites:', err);
        setFavorites([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  return (
    <>
      {/* Favorites List Modal */}
      <Modal show onHide={onClose} centered size="lg" backdrop="static">
        <Modal.Header className="bg-purple text-white">
          <Modal.Title className="text-warning fw-bold">Favorite Posts</Modal.Title>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onClose}
          />
        </Modal.Header>

        <Modal.Body className="bg-dark text-light">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: 150 }}>
              <Spinner animation="border" variant="light" />
            </div>
          ) : favorites.length === 0 ? (
            <p className="text-center text-muted">
              You have no favorite posts yet.
            </p>
          ) : (
            <ListGroup variant="flush">
              {favorites.map(post => (
                <ListGroup.Item
                  key={post.id}
                  action
                  className="bg-dark text-light border-secondary"
                  onClick={() => setSelectedPost(post)}
                >
                  <strong>{post.postTitle}</strong>
                  <div className="small text-muted">{post.category}</div>
                  <div className="small text-secondary">
                    {post.postText?.substring(0, 80)}…
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Modal.Body>

        <Modal.Footer className="bg-dark">
          <Button variant="outline-light" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Detail View Modal */}
      {selectedPost && (
        <Modal
          show
          onHide={() => setSelectedPost(null)}
          centered
          size="lg"
          backdrop="static"
        >
          <Modal.Header className="bg-purple text-white">
            <Button
              variant="outline-light"
              size="sm"
              onClick={() => setSelectedPost(null)}
            >
              ← Back
            </Button>
            <Modal.Title className="ms-3 text-warning">
              {selectedPost.postTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-dark">
            <PostCard post={selectedPost} currentUserId={userId} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
